import request from "@/utils/request.js";
export function fetchUserInfo() {
    return request({
        url: '/user',
        method: 'GET'
    })
}

export function login(data) {
    return request({
        url: '/v2/login',
        method: 'POST',
        data
    })
}